import axios from 'axios';
import { setAuthHeader, removeAuthHeader } from './common';
import { BASE_API_URL } from 'utils/constants';
import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();

export const get = async (
  baseApi: string,
  url: string,
  params?: object,
  shouldSetAuthHeader = true,
  shouldRemoveAuthHeader = false,
) => {
  if (shouldSetAuthHeader) {
    setAuthHeader();
  }
  if (shouldRemoveAuthHeader) {
    removeAuthHeader();
  }

  return await axios.get('/' + url, {
    baseURL: baseApi,
    params: {
      ...params,
    }
  });
};

export const deleted = async (
  baseApi: string,
  url: string,
  params?: object,
  shouldSetAuthHeader = true,
  shouldRemoveAuthHeader = false,
) => {
  if (shouldSetAuthHeader) {
    setAuthHeader();
  }
  if (shouldRemoveAuthHeader) {
    removeAuthHeader();
  }

  return await axios.delete('/' + url, {
    baseURL: baseApi,
    params: {
      ...params,
    }
  }).catch((e) => {
    if (e.response) {
      if (e.response.status !== 200) {
        alert('Status: ' + e.response.status + '\n' + e.message);
        console.log(e);
      }
      return e;
    }
  })

};

export const downloadFileGet = async (
  url: string,
  // params : string,
  shouldSetAuthHeader = true,
  shouldRemoveAuthHeader = false,
) => {
  if (shouldSetAuthHeader) {
    setAuthHeader();
  }
  if (shouldRemoveAuthHeader) {
    removeAuthHeader();
  }
  await axios({
    url: BASE_API_URL + '/' + url,
    method: 'GET',
    responseType: 'blob',
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const fileName = response.headers['content-disposition'].split(';')[1].replace('filename=', '');
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName); //or any other extension
    document.body.appendChild(link);
    link.click();
  }).catch((e) => {
    if (e.response) {
      if (e.response.status !== 200) {
        alert('Status: ' + e.response.status + '\n' + e.message);
        console.log(e);
      }
      return e;
    }
  })

};

export async function downloadFilePost<T = unknown>(
  url: string,
  params: T,
  shouldSetAuthHeader = true,
  shouldRemoveAuthHeader = false,
) {
  if (shouldSetAuthHeader) {
    setAuthHeader();
  }
  if (shouldRemoveAuthHeader) {
    removeAuthHeader();
  }
  await axios({
    url: BASE_API_URL + '/' + url,
    method: 'POST',
    responseType: 'blob',
    data: params,
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const fileName = response.headers['content-disposition'].split(';')[1].replace('filename=', '').trim();
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName); //or any other extension
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }).catch((e) => {
    if (e.response) {
      if (e.response.status !== 200) {
        alert('Status: ' + e.response.status + '\n' + e.message);
        console.log(e);
      }
      return e;
    }
  })

}

export async function downloadFilePostNew<T = unknown>(
  baseApi: string,
  url: string,
  params: T,
  shouldSetAuthHeader = true,
  shouldRemoveAuthHeader = false,
) {
  if (shouldSetAuthHeader) {
    setAuthHeader();
  }
  if (shouldRemoveAuthHeader) {
    removeAuthHeader();
  }
  await axios({
    url: '/' + url,
    method: 'POST',
    responseType: 'blob',
    data: params,
    baseURL: baseApi,
  })
    .catch((e) => {
      if (e.response) {
        if (e.response.status !== 200) {
          alert('Status: ' + e.response.status + '\n' + e.message);
          console.log(e);
        }
        return e;
      }
    })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      let fileName = response.headers['content-disposition'].split(';')[1].replace('filename=', '').trim();

      const fileName2 = fileName.replace(/[^.,\w\s]/g, '');

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName2); //or any other extension
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
}

export async function post<T = unknown>(
  baseApi: string,
  url: string,
  params: T,
  shouldSetAuthHeader = true,
  shouldRemoveAuthHeader = false,
) {
  if (shouldSetAuthHeader) {
    setAuthHeader();
  }
  if (shouldRemoveAuthHeader) {
    removeAuthHeader();
  }
  // axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
  return await axios.post(baseApi + '/' + url, params).catch((e) => {
    if (e.response) {
      if (e.response.status !== 200) {
        alert('Status: ' + e.response.status + '\n' + e.response.data.message);
      }
      return e.response;
    }
  });
}

export async function put<T = unknown>(
  baseApi: string,
  url: string,
  params: T,
  shouldSetAuthHeader = true,
  shouldRemoveAuthHeader = false,
) {
  if (shouldSetAuthHeader) {
    setAuthHeader();
  }
  if (shouldRemoveAuthHeader) {
    removeAuthHeader();
  }
  return await axios.put(baseApi + '/' + url, params).catch((e) => {
    if (e.response) {
      if (e.response.status !== 200) {
        alert('Status: ' + e.response.status + '\n' + e.response.data.message);
      }
      return e.response;
    }
  });
}
